import styled from 'styled-components'
import * as All from '../BaseStyles'

export const AppTypeHeaderDiv = styled(All.Div)`
    display: flex;
`

export const HeaderSectionDiv = styled(All.Div)`
    width: 100%;
    text-align: center; 
    font-size: 2rem;
    margin: 1.5rem 0rem;
    font-weight: 550;
`

export const AppTypeDiv = styled(HeaderSectionDiv)`
    border-left: 0.001rem solid black;
    border-right: 0.001rem solid black;
`
